<template>
  <div class="user-block clearfix" :class="size" v-if="user">
    <Avatar :size="size" :online="user.online" :src="user.avatar">
      <template v-if="noPhotoDisplay">{{ $t('noPhoto') }}</template>
    </Avatar>
    <div class="info">
      <div v-if="user" class="name">{{ $localized(user.localized_name, user.first_name) }} {{ $localized(user.localized_surname, user.last_name) }}</div>
      <Role :role="user.role" />
    </div>
    <div class="about description" @click="$emit('about')">
      {{ user.description }}
    </div>
  </div>
</template>
<script>
import Avatar from '@/components/user/Avatar'
import Role from '@/components/user/Role'

export default {
  name: 'User',
  components: { Avatar, Role },
  props: {
    user: Object,
    size: {
      default: 'xl',
    },
    noPhotoDisplay: {
      default: false,
    },
  },
}
</script>

<style lang="scss">
.user-block {
  .avatar {
    float: left;
    margin-right: 42px;

    @include mobile {
      margin-right: 30px;
    }
  }

  .info {
    font-weight: 400;
    font-size: 15px;
    line-height: 157.5%;
    min-height: 52px;
  }

  .name {
    font-weight: 700;
    font-size: 15px;
    line-height: 20px;
    color: #474747;

    @include mobile {
      font-size: 14px;
      line-height: 117%;
      letter-spacing: -0.01em;
    }
  }

  .about {
    @include mobile {
      font-weight: 400;
      font-size: 15px;
      line-height: 157.5%;
      width: 100%;
    }
  }

  //.about {
  //  &.description {
  //    margin-top: 13px !important;
  //
  //    font-weight: 400;
  //    font-size: 15px;
  //    line-height: 157.5%;
  //    color: #474747;
  //
  //    clear: both;
  //
  //    @include mobile {
  //      margin-top: 26px;
  //    }
  //  }
  //}

  &.md {
    .avatar {
      margin-right: 15px;
      margin-bottom: 22px;
    }

    .info {
      height: 69px;
      padding-top: 10px;
    }
  }

  @include PC {
    .info {
      height: auto;
    }

    .name {
      margin-bottom: -2px;
    }

    .about {
      font-weight: 400;
      font-size: 15px;
      line-height: 157.5%;
      margin-top: 18px;
      clear: none;
    }
  }
}
</style>
